'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import { DebateSettledStepAnimation } from '@/components/support-mainnet/how-it-works/debate-settled-step-animation';
import { howItWorksStepCopyFooterClass, howItWorksStepVisualClass } from '@/components/support-mainnet/how-it-works/how-it-works-step-card-layout';
import { HowItWorksStepCardShell } from '@/components/support-mainnet/how-it-works/how-it-works-step-card-shell';
import { HowItWorksStepCopy } from '@/components/support-mainnet/how-it-works/how-it-works-step-copy';
import { cn } from '@/lib/ui/utils';
export function HowItWorksDebateSettledStepCard(t0) {
  const $ = _c(4);
  const {
    title,
    description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={cn(howItWorksStepVisualClass, "overflow-visible")}><DebateSettledStepAnimation /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== description || $[2] !== title) {
    t2 = <HowItWorksStepCardShell stepIndex={2} testId="how-it-works-step-debateSettled">{t1}<div className={howItWorksStepCopyFooterClass}><HowItWorksStepCopy description={description} title={title} /></div></HowItWorksStepCardShell>;
    $[1] = description;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}